export default "__VITE_ASSET__Hg5kmjiR__"